/* Значок из строки SVG (реестры BotCore.I и SteosUI.icons) без обёртки: <svg> встаёт прямо на место, как в разметке прототипа.
   Атрибуты корня переводятся в имена React, содержимое вставляется как есть. */
import { memo, type SVGProps } from 'react';

const RE = /^\s*<svg\b([^>]*)>([\s\S]*)<\/svg>\s*$/;
const ATTR = /([:\w-]+)\s*=\s*"([^"]*)"/g;
const camel = (k: string) => (k === 'class' ? 'className' : /^(aria|data)-/.test(k) ? k : k.replace(/[-:]([a-z])/g, (_, c: string) => c.toUpperCase()));

interface Parsed {
  attrs: Record<string, string>;
  inner: string;
}
const cache = new Map<string, Parsed | null>();
function parse(svg: string): Parsed | null {
  let p = cache.get(svg);
  if (p !== undefined) return p;
  const m = RE.exec(svg);
  p = m ? { attrs: Object.fromEntries([...m[1].matchAll(ATTR)].map(a => [camel(a[1]), a[2]])), inner: m[2] } : null;
  cache.set(svg, p);
  return p;
}

export const Svg = memo(function Svg({ svg, ...rest }: { svg: string } & SVGProps<SVGSVGElement>) {
  const p = parse(svg);
  if (!p) return null;
  return <svg {...(p.attrs as SVGProps<SVGSVGElement>)} {...rest} dangerouslySetInnerHTML={{ __html: p.inner }} />;
});

const IMG = /^\s*<img\b([^>]*?)\/?>\s*$/;
const imgCache = new Map<string, Record<string, string> | null>();

/** Готовая разметка значка из ядра (<svg> или <img>, как BotCore.sid.logo) — без обёртки */
export const Mark = memo(function Mark({ html }: { html: string }) {
  if (RE.test(html)) return <Svg svg={html} />;
  let a = imgCache.get(html);
  if (a === undefined) {
    const m = IMG.exec(html);
    a = m ? Object.fromEntries([...m[1].matchAll(ATTR)].map(x => [camel(x[1]), x[2].replace(/&amp;/g, '&')])) : null;
    imgCache.set(html, a);
  }
  return a ? <img {...a} /> : null;
});
